import {
  Ee,
  M,
  a,
  c,
  d,
  gt,
  h,
  j,
  n,
  ne,
  p,
  w,
  x,
  y,
  z
} from "./chunk-R4FTT3DN.js";
import "./chunk-J43GMYXM.js";

// node_modules/patronum/and/index.js
function and() {
  for (var _len = arguments.length, stores = new Array(_len), _key = 0; _key < _len; _key++) {
    stores[_key] = arguments[_key];
  }
  return p({
    and: [stores, (values) => {
      for (var value of values) {
        if (!value) {
          return false;
        }
      }
      return true;
    }],
    or: {
      sid: "-rbm5ks"
    }
  });
}

// node_modules/patronum/combine-events/index.js
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function combineEvents(_ref) {
  var {
    events,
    reset: reset2,
    target = d({
      name: "target",
      sid: "3pez5"
    }, {
      name: "target",
      sid: "3pez5"
    })
  } = _ref;
  if (!ne.unit(target))
    throwError("target should be a unit");
  if (reset2 && !ne.unit(reset2))
    throwError("reset should be a unit");
  n(target, () => {
    var keys = Object.keys(events);
    var defaultShape = Array.isArray(events) ? [...keys].fill("") : {};
    var $counter = c(keys.length, {
      and: {
        serialize: "ignore"
      },
      name: "$counter",
      sid: "-dszn9a"
    });
    var $results = c(defaultShape, {
      and: {
        serialize: "ignore"
      },
      name: "$results",
      sid: "boz3x7"
    });
    $counter.reset(x({
      and: [{
        source: target
      }],
      or: {
        sid: "-8yzcn6"
      }
    }));
    $results.reset(target);
    if (reset2) {
      $counter.reset(x({
        and: [{
          source: reset2
        }],
        or: {
          sid: "-72suil"
        }
      }));
      $results.reset(reset2);
    }
    var _loop = function _loop2(key2) {
      var $isDone = c(false, {
        and: {
          serialize: "ignore"
        },
        name: "$isDone",
        sid: "ucs7nc"
      }).on(events[key2], () => true).reset(target);
      if (reset2) {
        $isDone.reset(reset2);
      }
      $counter.on($isDone, (value) => value - 1);
      $results.on(events[key2], (shape, payload) => {
        var newShape = Array.isArray(shape) ? [...shape] : _objectSpread({}, shape);
        newShape[key2] = payload;
        return newShape;
      });
    };
    for (var key of keys) {
      _loop(key);
    }
    z({
      and: [{
        source: x({
          and: [{
            source: $results,
            clock: w(Object.values(events), {
              name: "clock",
              sid: "-5k316x"
            })
          }],
          or: {
            name: "source",
            sid: "uf92v9"
          }
        }),
        filter: $counter.map((value) => value === 0),
        target
      }],
      or: {
        sid: "ciekm0"
      }
    });
  });
  return target;
}
function throwError(message) {
  throw new Error(message);
}

// node_modules/patronum/condition/index.js
function condition(_ref) {
  var {
    if: test,
    then: thenBranch,
    else: elseBranch,
    source = d({
      name: "source",
      sid: "epke23"
    }, {
      name: "source",
      sid: "epke23"
    })
  } = _ref;
  var checker = ne.unit(test) || isFunction(test) ? test : (value) => value === test;
  if (thenBranch && elseBranch) {
    j({
      and: [{
        source,
        match: {
          then: checker,
          else: inverse(checker)
        },
        cases: {
          then: thenBranch,
          else: elseBranch
        }
      }],
      or: {
        sid: "9tug3k"
      }
    });
  } else if (thenBranch) {
    z({
      and: [{
        source,
        filter: checker,
        target: thenBranch
      }],
      or: {
        sid: "abznoh"
      }
    });
  } else if (elseBranch) {
    z({
      and: [{
        source,
        filter: inverse(checker),
        target: elseBranch
      }],
      or: {
        sid: "-eb29qp"
      }
    });
  }
  return source;
}
function isFunction(value) {
  return typeof value === "function";
}
function inverse(fnOrUnit) {
  if (ne.unit(fnOrUnit)) {
    return fnOrUnit.map((value) => !value);
  }
  return (value) => !fnOrUnit(value);
}

// node_modules/patronum/debounce/index.js
function debounce(_ref) {
  var {
    source,
    timeout,
    target
  } = _ref;
  if (!ne.unit(source))
    throw new TypeError("source must be unit from effector");
  if (ne.domain(source, {
    sid: "jne2ft"
  }))
    throw new TypeError("source cannot be domain");
  var $timeout = toStoreNumber(timeout);
  var saveTimeoutId = d({
    name: "saveTimeoutId",
    sid: "eqtrwk"
  });
  var $timeoutId = c(null, {
    and: {
      serialize: "ignore"
    },
    name: "$timeoutId",
    sid: "-5hlcyp"
  }).on(saveTimeoutId, (_, id) => id);
  var saveReject = d({
    name: "saveReject",
    sid: "-m6vk0"
  });
  var $rejecter = c(null, {
    and: {
      serialize: "ignore"
    },
    name: "$rejecter",
    sid: "tqvf32"
  }).on(saveReject, (_, rj) => rj);
  var tick = target !== null && target !== void 0 ? target : d({
    name: "tick",
    sid: "-6wklwe"
  });
  var timerBaseFx = h((_ref2) => {
    var {
      parameter,
      timeout: timeout2,
      timeoutId,
      rejectPromise
    } = _ref2;
    if (timeoutId)
      clearTimeout(timeoutId);
    if (rejectPromise)
      rejectPromise();
    return new Promise((resolve, reject) => {
      saveReject(reject);
      saveTimeoutId(setTimeout(resolve, timeout2, parameter));
    });
  }, {
    name: "timerBaseFx",
    sid: "-xd98qa"
  });
  var timerFx = y({
    and: {
      source: {
        timeoutId: $timeoutId,
        rejectPromise: $rejecter
      },
      mapParams: (_ref3, _ref4) => {
        var {
          parameter,
          timeout: timeout2
        } = _ref3;
        var {
          timeoutId,
          rejectPromise
        } = _ref4;
        return {
          parameter,
          timeout: timeout2,
          timeoutId,
          rejectPromise
        };
      },
      effect: timerBaseFx
    },
    or: {
      name: "timerFx",
      sid: "-4ab544"
    }
  });
  $rejecter.reset(timerFx.done);
  $timeoutId.reset(timerFx.done);
  x({
    and: [{
      source: $timeout,
      clock: source,
      fn: (timeout2, parameter) => ({
        timeout: timeout2,
        parameter
      }),
      target: timerFx
    }],
    or: {
      sid: "m29k3f"
    }
  });
  gt({
    and: {
      from: timerFx.done.map((_ref5) => {
        var {
          result
        } = _ref5;
        return result;
      }),
      to: tick
    },
    or: {
      sid: "-32ktwy"
    }
  });
  return tick;
}
function toStoreNumber(value) {
  if (ne.store(value, {
    sid: "-2xmoh9"
  }))
    return value;
  if (typeof value === "number") {
    if (value < 0 || !Number.isFinite(value))
      throw new Error('timeout must be positive number or zero. Received: "'.concat(value, '"'));
    return c(value, {
      and: {
        name: "$timeout"
      },
      sid: "-757cx6"
    });
  }
  throw new TypeError('timeout parameter in interval method should be number or Store. "'.concat(typeof value, '" was passed'));
}

// node_modules/patronum/debug/index.js
function isConfig(maybeConfig) {
  if (!ne.unit(maybeConfig)) {
    return !Object.values(maybeConfig).every(ne.unit);
  }
  return false;
}
function debug() {
  var config = {
    trace: false
  };
  for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
    units[_key] = arguments[_key];
  }
  var [maybeConfig, ...restUnits] = units;
  if (isConfig(maybeConfig)) {
    config = maybeConfig;
  } else if (!ne.unit(maybeConfig)) {
    for (var [name, unit] of Object.entries(maybeConfig)) {
      customNames.set(getGraph(unit).id, name);
      logUnit(unit, config);
    }
  } else {
    logUnit(maybeConfig);
  }
  for (var maybeUnit of restUnits) {
    if (ne.unit(maybeUnit)) {
      logUnit(maybeUnit, config);
    } else {
      for (var [_name, _unit] of Object.entries(maybeUnit)) {
        customNames.set(getGraph(_unit).id, _name);
        logUnit(_unit, config);
      }
    }
  }
}
function getType(unit) {
  if (ne.store(unit, {
    sid: "-h7y2t9"
  })) {
    return "store";
  }
  if (ne.effect(unit, {
    sid: "-h6ap16"
  })) {
    return "effect";
  }
  if (ne.event(unit, {
    sid: "-h4nb93"
  })) {
    return "event";
  }
  if (ne.domain(unit, {
    sid: "-grg90f"
  })) {
    return "domain";
  }
  if (ne.unit(unit)) {
    return "unit";
  }
  return "unknown";
}
var debugStores = [];
function log(unit, type) {
  var prefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  var name = prefix + getName(unit);
  if (ne.store(unit, {
    sid: "-g609vc"
  })) {
    logUpdate({
      type,
      name,
      value: unit.getState()
    });
    scopes.forEach((scope, meta) => {
      logUpdate({
        type,
        name,
        scopeName: meta.name,
        value: scope.getState(unit)
      });
    });
    debugStores.push(unit);
  }
  a({
    parent: [unit],
    meta: {
      op: "watch"
    },
    family: {
      owners: unit
    },
    regional: true,
    node: [Ee.run({
      fn(_data, _scope, stack) {
        if (!stack.scope) {
          logUpdate({
            type,
            name,
            value: _data
          });
        } else {
          if (!scopes.get(stack.scope)) {
            scopes.save(stack.scope);
          }
          var _meta = scopes.get(stack.scope);
          logUpdate({
            type,
            name,
            scopeName: _meta === null || _meta === void 0 ? void 0 : _meta.name,
            value: _data
          });
        }
      }
    })]
  });
}
function logEffect(unit) {
  log(unit.done, "effect", getName(unit) + ".");
  log(unit.fail, "effect", getName(unit) + ".");
}
function getNode(node) {
  var actualNode = "graphite" in node ? node.graphite : node;
  return actualNode;
}
var customNames = /* @__PURE__ */ new Map();
function getName(unit) {
  var custom = customNames.get(getGraph(unit).id);
  if (custom) {
    return custom;
  }
  if (unit.compositeName && unit.compositeName.fullName) {
    return unit.compositeName.fullName;
  }
  if (unit.shortName) {
    return unit.shortName;
  }
  if (unit.name) {
    return unit.name;
  }
  return "";
}
function readLoc(_ref) {
  var {
    meta
  } = _ref;
  var loc = "config" in meta ? meta.config.loc : meta.loc;
  return loc;
}
function getLoc(unit) {
  var _loc$file;
  var loc = readLoc(unit);
  if (!loc)
    return null;
  return "".concat((_loc$file = loc.file) !== null && _loc$file !== void 0 ? _loc$file : "", ":").concat(loc.line, ":").concat(loc.column);
}
function logUnit(unit, config) {
  var type = getType(unit);
  if (ne.store(unit, {
    sid: "zfed9z"
  }) || ne.effect(unit, {
    sid: "wsoi2z"
  }) || ne.event(unit, {
    sid: "wsojji"
  })) {
    log(unit, type);
    if (config !== null && config !== void 0 && config.trace) {
      logTrace(unit);
    }
  }
  if (ne.effect(unit, {
    sid: "-zhbby9"
  })) {
    logEffect(unit);
  }
  if (ne.domain(unit, {
    sid: "-p5meu5"
  })) {
    unit.onCreateEvent((event) => {
      log(event, "event");
      if (config !== null && config !== void 0 && config.trace) {
        logTrace(event);
      }
    });
    unit.onCreateStore((store) => {
      log(store, "store");
      if (config !== null && config !== void 0 && config.trace) {
        logTrace(store);
      }
    });
    unit.onCreateEffect((effect) => {
      log(effect, "effect");
      logEffect(effect);
      if (config !== null && config !== void 0 && config.trace) {
        logTrace(effect);
      }
    });
  }
}
function isEffectChild(node) {
  var actualNode = getNode(node);
  var {
    sid,
    named
  } = actualNode.meta;
  return Boolean(!sid && (named === "finally" || named === "done" || named === "doneData" || named === "fail" || named === "failData" || named === "inFlight" || named === "pending"));
}
function getNodeName(node) {
  if (!node)
    return "";
  var {
    meta,
    id
  } = node;
  var customName = customNames.get(id);
  if (customName) {
    return customName;
  }
  if (!isEffectChild(node)) {
    return meta.name;
  }
  var parentEffect = node.family.owners.find((n2) => n2.meta.op === "effect");
  if (parentEffect) {
    return "".concat(getNodeName(parentEffect), ".").concat(meta.named);
  }
  return meta.named;
}
function logTrace(unit) {
  var type = getType(unit);
  var name = getName(unit);
  a({
    parent: [unit],
    meta: {
      op: "watch"
    },
    family: {
      owners: unit
    },
    regional: true,
    node: [Ee.run({
      fn(_data, _scope, stack) {
        var parent = stack === null || stack === void 0 ? void 0 : stack.parent;
        var scopeMeta = scopes.get(stack === null || stack === void 0 ? void 0 : stack.scope);
        var scopeName = scopeMeta ? " (scope: ".concat(scopeMeta.name, ")") : "";
        var groupName = "[".concat(type, "]").concat(scopeName, " ").concat(name, " trace");
        console.groupCollapsed(groupName);
        while (parent) {
          var {
            node,
            value
          } = parent;
          var {
            meta: _meta2
          } = node;
          var opName = _meta2.op;
          var unitName = getNodeName(node);
          if (!unitName) {
            var _getLoc;
            unitName = (_getLoc = getLoc(node)) !== null && _getLoc !== void 0 ? _getLoc : "";
          }
          if (opName === "on") {
            var _parent$parent;
            var parentStore = getNodeName(node.next[0]);
            opName = "".concat(parentStore, ".").concat(_meta2.op);
            unitName = "".concat(parentStore, ".").concat(_meta2.op, "(").concat(getNodeName((_parent$parent = parent.parent) === null || _parent$parent === void 0 ? void 0 : _parent$parent.node), ")");
          }
          console.info("<- [".concat(opName, "] ").concat(unitName), value);
          parent = parent.parent;
        }
        console.groupEnd();
      }
    })]
  });
}
function registerScope(scope, config) {
  scopes.save(scope, {
    name: config.name
  });
  debugStores.forEach((store) => {
    logUpdate({
      type: "store",
      name: getName(store),
      scopeName: config.name,
      value: scope.getState(store)
    });
  });
  return () => {
    scopes.delete(scope);
  };
}
function unregisterAllScopes() {
  scopes.clear();
}
debug.registerScope = registerScope;
debug.unregisterAllScopes = unregisterAllScopes;
function logUpdate(_ref2) {
  var {
    type,
    scopeName,
    name,
    value
  } = _ref2;
  var typeString = "[".concat(type, "]");
  var scopeNameString = scopeName ? " (scope: ".concat(scopeName, ")") : "";
  var nameString = " ".concat(name);
  console.info("".concat(typeString).concat(scopeNameString).concat(nameString), value);
}
var getGraph = (graph) => graph.graphite || graph;
var cache = /* @__PURE__ */ new Map();
var unknownScopes = 0;
function getDefaultName() {
  unknownScopes += 1;
  return "unknown_scope_".concat(unknownScopes);
}
var scopes = {
  save(scope, meta) {
    if (!scopes.get(scope)) {
      cache.set(scope, meta !== null && meta !== void 0 ? meta : {
        name: getDefaultName()
      });
    }
  },
  get(scope) {
    var _cache$get;
    if (!scope)
      return null;
    return (_cache$get = cache.get(scope)) !== null && _cache$get !== void 0 ? _cache$get : null;
  },
  delete(scope) {
    cache.delete(scope);
  },
  forEach(callback) {
    cache.forEach((meta, scope) => callback(scope, meta));
  },
  clear() {
    cache.clear();
  }
};

// node_modules/patronum/delay/index.js
function delay(_ref) {
  var {
    source,
    timeout,
    target = d({
      name: "target",
      sid: "-z2vw3w"
    }, {
      name: "target",
      sid: "-z2vw3w"
    })
  } = _ref;
  if (!ne.unit(source))
    throw new TypeError("source must be a unit from effector");
  if (!ne.unit(target))
    throw new TypeError("target must be a unit from effector");
  var ms = validateTimeout(timeout);
  var timerFx = h((_ref2) => {
    var {
      payload,
      milliseconds
    } = _ref2;
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds, payload);
    });
  }, {
    name: "timerFx",
    sid: "-584o7j"
  });
  x({
    and: [{
      source: p({
        and: [{
          milliseconds: ms
        }],
        or: {
          name: "source",
          sid: "9rbdjo"
        }
      }),
      clock: source,
      fn: (_ref3, payload) => {
        var {
          milliseconds
        } = _ref3;
        return {
          payload,
          milliseconds: typeof milliseconds === "function" ? milliseconds(payload) : milliseconds
        };
      },
      target: timerFx
    }],
    or: {
      sid: "-wmj29s"
    }
  });
  gt({
    and: {
      from: timerFx.doneData,
      to: target
    },
    or: {
      sid: "-vsadmx"
    }
  });
  return target;
}
function validateTimeout(timeout) {
  if (ne.store(timeout, {
    sid: "-va560a"
  }) || typeof timeout === "function" || typeof timeout === "number") {
    return timeout;
  }
  throw new TypeError(`'timeout' argument must be a function, Store, or a number. Passed "`.concat(typeof timeout, '"'));
}

// node_modules/patronum/either/index.js
function either(filterOptions, then, other) {
  if (ne.store(filterOptions, {
    sid: "ozzvoc"
  })) {
    return p({
      and: [filterOptions, then, other, (filter, then2, other2) => filter ? then2 : other2],
      or: {
        sid: "-5vau2h"
      }
    });
  }
  var objectForm = filterOptions;
  return either(objectForm.filter, objectForm.then, objectForm.other);
}

// node_modules/patronum/empty/index.js
function empty(source) {
  return source.map((value) => value === null);
}

// node_modules/patronum/equals/index.js
function equals(a2, b) {
  return p({
    and: [a2, b, (a3, b2) => a3 === b2],
    or: {
      sid: "-pqjlti"
    }
  });
}

// node_modules/patronum/every/index.js
function every(configOrStores, predicateOrNone) {
  var stores = [];
  var predicate = () => false;
  if (Array.isArray(configOrStores)) {
    stores = configOrStores;
    predicate = predicateOrNone;
  } else if (Array.isArray(configOrStores.stores)) {
    stores = configOrStores.stores;
    predicate = configOrStores.predicate;
  }
  var checker;
  if (isFunction2(predicate)) {
    checker = predicate;
  } else if (ne.store(predicate, {
    sid: "sid3ut"
  })) {
    checker = predicate.map((value) => (required) => value === required);
  } else {
    checker = (value) => value === predicate;
  }
  var $values = p({
    and: [stores],
    or: {
      name: "$values",
      sid: "h09uhg"
    }
  });
  var $checker = checker;
  return p({
    and: [$checker, $values, (checker2, values) => values.every(checker2)],
    or: {
      sid: "hfkdw9"
    }
  });
}
function isFunction2(value) {
  return typeof value === "function";
}

// node_modules/patronum/format/index.js
function format(strings) {
  for (var _len = arguments.length, stores = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    stores[_key - 1] = arguments[_key];
  }
  return p({
    and: [stores, (stores2) => strings.reduce((acc, value, index) => acc.concat(isLastElement(strings, index) ? value : "".concat(value).concat(toString(stores2[index]))), "")],
    or: {
      sid: "-yrbthp"
    }
  });
}
function toString(value) {
  if (Array.isArray(value)) {
    return value.map((value2) => String(value2)).join(", ");
  }
  return String(value);
}
function isLastElement(array, index) {
  return index === array.length - 1;
}

// node_modules/patronum/in-flight/index.js
function inFlight(_ref) {
  var {
    effects,
    domain
  } = _ref;
  if (domain) {
    var $inFlight = domain.createStore(0, {
      name: "$inFlight",
      sid: "-y7vg7t"
    });
    domain.onCreateEffect((fx) => {
      $inFlight.on(fx, (count) => count + 1).on(fx.finally, (count) => count - 1);
    });
    return $inFlight;
  }
  return p({
    and: [effects.map((fx) => fx.inFlight), (inFlights) => inFlights.reduce((all, current) => all + current, 0)],
    or: {
      sid: "ubqxa7"
    }
  });
}

// node_modules/patronum/interval/index.js
function interval(_ref) {
  var {
    timeout,
    start,
    stop,
    leading = false,
    trailing = false
  } = _ref;
  var tick = d({
    name: "tick",
    sid: "u782pl"
  });
  var $isRunning = c(false, {
    name: "$isRunning",
    sid: "-xegewf"
  });
  var $timeout = toStoreNumber2(timeout);
  var $notRunning = $isRunning.map((running) => !running);
  var saveTimeout = d({
    name: "saveTimeout",
    sid: "ab3q7d"
  });
  var $timeoutId = c(null, {
    name: "$timeoutId",
    sid: "-aj5rja"
  }).on(saveTimeout, (_, _ref2) => {
    var {
      timeoutId
    } = _ref2;
    return timeoutId;
  });
  var $rejecter = c(() => {
  }, {
    name: "$rejecter",
    sid: "opb0ih"
  }).on(saveTimeout, (_, _ref3) => {
    var {
      reject
    } = _ref3;
    return reject;
  });
  var timeoutFx = y({
    and: {
      source: {
        timeout: $timeout,
        running: $isRunning
      },
      effect: (_ref4) => {
        var {
          timeout: timeout2,
          running
        } = _ref4;
        if (!running) {
          return Promise.reject();
        }
        return new Promise((resolve, reject) => {
          var timeoutId = setTimeout(resolve, timeout2);
          saveTimeout({
            timeoutId,
            reject
          });
        });
      }
    },
    or: {
      name: "timeoutFx",
      sid: "9hil7b"
    }
  });
  var cleanupFx = y({
    and: {
      source: {
        timeoutId: $timeoutId,
        rejecter: $rejecter
      },
      effect: (_ref5) => {
        var {
          timeoutId,
          rejecter
        } = _ref5;
        rejecter();
        if (timeoutId)
          clearTimeout(timeoutId);
      }
    },
    or: {
      name: "cleanupFx",
      sid: "-v02m7d"
    }
  });
  z({
    and: [{
      clock: start,
      source: $timeout,
      filter: $notRunning,
      target: timeoutFx
    }],
    or: {
      sid: "-vop0ii"
    }
  });
  if (leading) {
    var onReady = z({
      and: [{
        clock: start,
        filter: $notRunning
      }],
      or: {
        name: "onReady",
        sid: "-cmw7lh"
      }
    });
    x({
      and: [{
        clock: onReady,
        target: tick
      }],
      or: {
        sid: "-v876ny"
      }
    });
  }
  x({
    and: [{
      clock: start,
      fn: () => true,
      target: $isRunning
    }],
    or: {
      sid: "-v6jsxl"
    }
  });
  z({
    and: [{
      clock: timeoutFx.done,
      source: $timeout,
      filter: $isRunning,
      target: timeoutFx
    }],
    or: {
      sid: "-urpcwu"
    }
  });
  z({
    and: [{
      clock: timeoutFx.done,
      filter: $isRunning,
      target: tick.prepend(() => {
      })
    }],
    or: {
      sid: "-ucb4aq"
    }
  });
  if (stop) {
    if (trailing) {
      x({
        and: [{
          clock: stop,
          target: tick
        }],
        or: {
          sid: "6lcn0o"
        }
      });
    }
    $isRunning.on(stop, () => false);
    x({
      and: [{
        clock: stop,
        target: cleanupFx
      }],
      or: {
        sid: "71ao6f"
      }
    });
  }
  return {
    tick,
    isRunning: $isRunning
  };
}
function toStoreNumber2(value) {
  if (ne.store(value, {
    sid: "7icamc"
  }))
    return value;
  if (typeof value === "number") {
    return c(value, {
      and: {
        name: "$timeout"
      },
      sid: "knc3em"
    });
  }
  throw new TypeError('timeout parameter in interval method should be number or Store. "'.concat(typeof value, '" was passed'));
}

// node_modules/patronum/not/index.js
function not(source) {
  return source.map((value) => !value);
}

// node_modules/patronum/or/index.js
function or() {
  for (var _len = arguments.length, stores = new Array(_len), _key = 0; _key < _len; _key++) {
    stores[_key] = arguments[_key];
  }
  return p({
    and: [stores, (values) => {
      for (var value of values) {
        if (value) {
          return true;
        }
      }
      return false;
    }],
    or: {
      sid: "-44722k"
    }
  });
}

// node_modules/patronum/pending/index.js
var strategies = {
  some: (list) => list.some(Boolean),
  every: (list) => list.every(Boolean)
};
function pending(_ref) {
  var {
    effects: rawEffects,
    domain,
    of = "some"
  } = _ref;
  if (!ne.domain(domain, {
    sid: "97b92c"
  }) && !rawEffects)
    throw new TypeError("domain or effects should be passed");
  if (of !== "some" && of !== "every")
    throw new TypeError('strategy parameter "of" can be "every" or "some". Passed: "'.concat(of, '"'));
  var effects = rawEffects !== null && rawEffects !== void 0 ? rawEffects : [];
  var strategy = strategies[of];
  if (domain) {
    effects = [];
    domain.onCreateEffect((fx) => effects.push(fx));
  }
  return p({
    and: [effects.map((fx) => fx.pending), strategy],
    or: {
      sid: "a37bj0"
    }
  });
}

// node_modules/patronum/reset/index.js
function reset(_ref) {
  var {
    clock,
    target
  } = _ref;
  var targets = Array.isArray(target) ? target : [target];
  var clocks = Array.isArray(clock) ? clock : [clock];
  targets.forEach((target2) => {
    target2.reset(clocks);
  });
}

// node_modules/patronum/reshape/index.js
function reshape(_ref) {
  var {
    source,
    shape
  } = _ref;
  var result = {};
  for (var key in shape) {
    if (key in shape) {
      (function() {
        var fn = shape[key];
        result[key] = source.map((state) => {
          var result2 = fn(state);
          return result2 === void 0 ? null : result2;
        });
      })();
    }
  }
  return result;
}

// node_modules/patronum/snapshot/index.js
function snapshot(_ref) {
  var {
    source,
    clock,
    fn = (value) => value
  } = _ref;
  var defaultValue = fn(source.defaultState);
  var onSnapshot = clock ? x({
    and: [{
      source,
      clock,
      fn
    }],
    or: {
      name: "onSnapshot",
      sid: "-auitd0"
    }
  }) : x({
    and: [{
      source,
      fn
    }],
    or: {
      name: "onSnapshot",
      sid: "-auiql4"
    }
  });
  var $snapshot = c(defaultValue, {
    name: "$snapshot",
    sid: "-7zyoaf"
  });
  $snapshot.on(onSnapshot, (_, value) => value);
  return $snapshot;
}

// node_modules/patronum/some/index.js
function some(configOrStores, predicateOrNone) {
  var stores = [];
  var predicate = () => false;
  if (Array.isArray(configOrStores)) {
    stores = configOrStores;
    predicate = predicateOrNone;
  } else if (Array.isArray(configOrStores.stores)) {
    stores = configOrStores.stores;
    predicate = configOrStores.predicate;
  }
  var checker;
  if (isFunction3(predicate)) {
    checker = predicate;
  } else if (ne.store(predicate, {
    sid: "zbwu0l"
  })) {
    checker = predicate.map((value) => (required) => value === required);
  } else {
    checker = (value) => value === predicate;
  }
  var $values = p({
    and: [stores],
    or: {
      name: "$values",
      sid: "-lv5do0"
    }
  });
  var $checker = checker;
  return p({
    and: [$checker, $values, (checker2, values) => values.some(checker2)],
    or: {
      sid: "-efc5w7"
    }
  });
}
function isFunction3(value) {
  return typeof value === "function";
}

// node_modules/patronum/split-map/index.js
function splitMap(_ref) {
  var {
    source,
    cases
  } = _ref;
  var result = {};
  var current = ne.store(source, {
    name: "current",
    sid: "-htjkz7"
  }) ? source.updates : source;
  for (var key in cases) {
    if (key in cases) {
      (function() {
        var _fn = cases[key];
        result[key] = current.filterMap(_fn);
        current = current.filter({
          fn: (data) => !_fn(data)
        });
      })();
    }
  }
  result.__ = current;
  return result;
}

// node_modules/patronum/spread/index.js
var hasPropBase = {}.hasOwnProperty;
var hasOwnProp = (object, key) => hasPropBase.call(object, key);
function spread(_ref) {
  var {
    targets,
    source = d({
      name: "source",
      sid: "-fkbi3c"
    }, {
      name: "source",
      sid: "-fkbi3c"
    })
  } = _ref;
  var _loop = function _loop2(targetKey2) {
    if (hasOwnProp(targets, targetKey2)) {
      var currentTarget = targets[targetKey2];
      var hasTargetKey = z({
        and: [{
          source,
          greedy: true,
          filter: (object) => typeof object === "object" && object !== null && targetKey2 in object
        }],
        or: {
          name: "hasTargetKey",
          sid: "-cov4g4"
        }
      });
      x({
        and: [{
          greedy: true,
          clock: hasTargetKey,
          fn: (object) => object[targetKey2],
          target: currentTarget
        }],
        or: {
          sid: "lpn34j"
        }
      });
    }
  };
  for (var targetKey in targets) {
    _loop(targetKey);
  }
  return source;
}

// node_modules/patronum/status/index.js
function status(_ref) {
  var {
    effect,
    defaultValue = "initial"
  } = _ref;
  var $status = c(defaultValue, {
    name: "$status",
    sid: "abrgim"
  });
  $status.on(effect, () => "pending").on(effect.done, () => "done").on(effect.fail, () => "fail");
  return $status;
}

// node_modules/patronum/throttle/index.js
function throttle(_ref) {
  var {
    source,
    timeout,
    target = d({
      name: "target",
      sid: "r328r6"
    }, {
      name: "target",
      sid: "r328r6"
    })
  } = _ref;
  if (!ne.unit(source))
    throw new TypeError("source must be unit from effector");
  var $timeout = toStoreNumber3(timeout);
  var timerFx = h((timeout2) => new Promise((resolve) => setTimeout(resolve, timeout2)), {
    name: "timerFx",
    sid: "-pyjx8k"
  });
  var start = z({
    and: [{
      clock: source,
      filter: timerFx.pending.map((pending2) => !pending2)
    }],
    or: {
      name: "start",
      sid: "-p67kgr"
    }
  });
  x({
    and: [{
      source: $timeout,
      clock: start,
      target: timerFx
    }],
    or: {
      sid: "-ievrvf"
    }
  });
  x({
    and: [{
      source,
      clock: timerFx.done,
      target
    }],
    or: {
      sid: "-i01buo"
    }
  });
  return target;
}
function toStoreNumber3(value) {
  if (ne.store(value, {
    sid: "-hl6vqh"
  }))
    return value;
  if (typeof value === "number") {
    if (value < 0 || !Number.isFinite(value))
      throw new Error('timeout must be positive number or zero. Received: "'.concat(value, '"'));
    return c(value, {
      and: {
        name: "$timeout"
      },
      sid: "pu8pon"
    });
  }
  throw new TypeError('timeout parameter should be number or Store. "'.concat(typeof value, '" was passed'));
}

// node_modules/patronum/time/index.js
var defaultNow = () => Date.now();
function time(_ref) {
  var {
    clock,
    getNow,
    initial
  } = _ref;
  var timeReader = getNow !== null && getNow !== void 0 ? getNow : defaultNow;
  var readNowFx = h(timeReader, {
    name: "readNowFx",
    sid: "459ysb"
  });
  var $time = M(readNowFx, initial !== null && initial !== void 0 ? initial : timeReader(), {
    name: "$time",
    sid: "-ys9vce"
  });
  gt({
    and: {
      from: clock,
      to: readNowFx
    },
    or: {
      sid: "rdje9v"
    }
  });
  return $time;
}
export {
  and,
  combineEvents,
  condition,
  debounce,
  debug,
  delay,
  either,
  empty,
  equals,
  every,
  format,
  inFlight,
  interval,
  not,
  or,
  pending,
  reset,
  reshape,
  snapshot,
  some,
  splitMap,
  spread,
  status,
  throttle,
  time
};
//# sourceMappingURL=patronum.js.map
